import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { cpf as cpfValidator } from "cpf-cnpj-validator";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";

const CadastroProfessor = () => {
  const navigate = useNavigate();
  const { parametros } = useCliente();

  const [formData, setFormData] = useState({
    cpf: "",
    nome_completo: "",
    genero: "",
    data_nascimento: "",
    cargo: "Professor",
    telefone: "",
    email: "",
    usuario: "",
    senha: ""
  });

  const [errors, setErrors] = useState({});

  // Disciplinas
  const [disciplinasDisponiveis, setDisciplinasDisponiveis] = useState([]);
  const [disciplinasSelecionadas, setDisciplinasSelecionadas] = useState([]);

  useEffect(() => {
    carregarDisciplinas();
  }, []);

  const carregarDisciplinas = async () => {
    try {
      const clienteId = localStorage.getItem("cliente_id");
      const response = await axios.get(`/api/disciplinas?cliente_id=${clienteId}`);
      setDisciplinasDisponiveis(response.data);
    } catch (error) {
      console.error("Erro ao carregar disciplinas:", error);
    }
  };

  const limparMascara = (valor) => valor.replace(/\D/g, "");

  const aplicarMascara = (campo, valor) => {
    const numeros = limparMascara(valor);
    if (campo === "cpf") {
      return numeros.slice(0, 11)
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    }
    return valor;
  };

  const validarCampo = (name, value) => {
    let mensagem = "";
    if (name === "cpf" && (!cpfValidator.isValid(limparMascara(value)) || limparMascara(value).length !== 11))
      mensagem = "CPF inválido.";
    if (name === "nome_completo" && (!value || value.trim().length < 3))
      mensagem = "Nome obrigatório com pelo menos 3 letras.";
    if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
      mensagem = "E-mail inválido.";
    if (name === "usuario" && (!value || value.trim().length < 3))
      mensagem = "Usuário obrigatório.";
    if (name === "senha" && (!value || value.length < 6))
      mensagem = "Senha deve ter pelo menos 6 caracteres.";
    if (name === "telefone" && limparMascara(value).length < 10)
      mensagem = "Telefone incompleto.";
    if (name === "data_nascimento") {
      const partes = value.split("-");
      const ano = partes[0];
      const hoje = new Date();
      const nascimento = new Date(value);
      if (!value || !ano || ano.length !== 4 || Number(ano) < 1900 || Number(ano) > hoje.getFullYear() || isNaN(nascimento.getTime()) || nascimento > hoje) {
        mensagem = "Data de nascimento inválida.";
      }
    }
    setErrors(prev => ({ ...prev, [name]: mensagem }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const novoValor = name === "cpf" ? aplicarMascara(name, value) : value;
    setFormData(prev => ({ ...prev, [name]: novoValor }));
    validarCampo(name, novoValor);
  };

  const validarFormulario = () => {
    const campos = ["nome_completo", "cpf", "email", "telefone", "usuario", "senha", "data_nascimento"];
    campos.forEach(campo => validarCampo(campo, formData[campo]));
    return Object.values(errors).every((erro) => !erro);
  };

  const handleCheckboxChange = (idDisciplina) => {
    setDisciplinasSelecionadas(prev =>
      prev.includes(idDisciplina)
        ? prev.filter(d => d !== idDisciplina)
        : [...prev, idDisciplina]
    );
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const clienteId = localStorage.getItem("cliente_id");
  
    if (!clienteId) {
      alert("Cliente não identificado. Faça login novamente.");
      return;
    }
  
    if (!validarFormulario()) {
      alert("Corrija os erros antes de salvar.");
      return;
    }
  
    try {
      const payload = {
        cpf: limparMascara(formData.cpf),
        nome_completo: formData.nome_completo,
        genero: formData.genero,
        data_nascimento: formData.data_nascimento || null,
        cargo: formData.cargo,
        telefone: limparMascara(formData.telefone),
        email: formData.email,
        usuario: formData.usuario,
        senha: formData.senha,
        tipo: "Professor",
        cliente_id: clienteId,
        usuario_id: parseInt(localStorage.getItem("user_id"), 10)
      };
  
      const response = await axios.post("/api/usuarios", payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });
  
      const novoProfessorId = response.data.id;
  
      // Se houver disciplinas selecionadas, vincular
      if (disciplinasSelecionadas.length > 0 && novoProfessorId) {
        await axios.post("/api/professor_disciplina", {
          professor_id: novoProfessorId,
          disciplinasSelecionadas
        }, {
          headers: {
            "Content-Type": "application/json"
          }
        });
      }
  
      alert("Professor cadastrado com sucesso!");
      navigate("/listagemprofessores");
  
    } catch (error) {
      console.error("Erro ao cadastrar professor:", error);
      alert(error.response?.data?.erro || "Erro ao cadastrar professor.");
    }
  };
  
  
 
  const renderErro = (campo) => errors[campo] && <span className="campo-erro">{errors[campo]}</span>;

  return (
    <div className="form-wrapper form-coordenador">
      <h2 className="form-title">Cadastrar Professor</h2>
      <form onSubmit={handleSubmit} noValidate>

        {/* Bloco de Dados Pessoais */}
        <div className="form-row">
          <div className="form-group campo-cpf" style={{ width: "160px" }}>
            <label>CPF</label>
            <input
              type="text"
              name="cpf"
              value={formData.cpf}
              onChange={handleChange}
              onBlur={handleChange}
              required
            />
            {renderErro("cpf")}
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Nome Completo</label>
            <input
              type="text"
              name="nome_completo"
              value={formData.nome_completo}
              onChange={handleChange}
              onBlur={handleChange}
              required
            />
            {renderErro("nome_completo")}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group campo-genero" style={{ width: "210px" }}>
            <label>Gênero</label>
            <select
              name="genero"
              value={formData.genero}
              onChange={handleChange}
              onBlur={handleChange}
            >
              <option value="">Selecione</option>
              <option value="Masculino">Masculino</option>
              <option value="Feminino">Feminino</option>
              <option value="Outro">Outro</option>
            </select>
          </div>

          <div className="form-group campo-data" style={{ width: "160px" }}>
            <label>Data de Nascimento</label>
            <input
              type="date"
              name="data_nascimento"
              value={formData.data_nascimento || ""}
              onChange={handleChange}
              onBlur={handleChange}
              required
            />
            {renderErro("data_nascimento")}
          </div>

          <div className="form-group" style={{ flex: 1 }}>
            <label>Cargo</label>
            <input
              type="text"
              name="cargo"
              value={formData.cargo}
              onChange={handleChange}
              onBlur={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group campo-telefone" style={{ width: "180px" }}>
            <label>Telefone</label>
            <input
              type="text"
              name="telefone"
              value={formData.telefone}
              onChange={handleChange}
              onBlur={handleChange}
            />
            {renderErro("telefone")}
          </div>

          <div className="form-group" style={{ flex: 1 }}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              onBlur={handleChange}
              required
            />
            {renderErro("email")}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group campo-usuario" style={{ width: "220px" }}>
            <label>Usuário</label>
            <input
              type="text"
              name="usuario"
              value={formData.usuario}
              onChange={handleChange}
              onBlur={handleChange}
              required
            />
            {renderErro("usuario")}
          </div>

          <div className="form-group" style={{ width: "220px" }}>
            <label>Senha</label>
            <input
              type="password"
              name="senha"
              value={formData.senha}
              onChange={handleChange}
              onBlur={handleChange}
              required
            />
            {renderErro("senha")}
          </div>
        </div>

        {/* Tabela de Disciplinas */}
        <hr className="linha-divisoria" />
        {disciplinasDisponiveis.length > 0 && (
          <div className="form-group full-width">
            <label>Disciplinas que o Professor pode lecionar:</label>
            <div style={{ overflowX: "auto", marginTop: "10px" }}>
              <table className="tabela" style={{ fontSize: "0.75rem" }}>
                <thead
                  style={{
                    backgroundColor: parametros?.cor_cabecalho || "#156082",
                    color: "white"
                  }}
                >
                  <tr>
                    <th style={{ width: "10%", textAlign: "center" }}>Selecionar</th>
                    <th style={{ width: "20%", textAlign: "left" }}>Código</th>
                    <th style={{ textAlign: "left" }}>Nome</th>
                  </tr>
                </thead>
                <tbody>
                  {disciplinasDisponiveis.map((d) => (
                    <tr key={d.id}>
                      <td style={{ textAlign: "center", padding: "8px" }}>
                        <input
                          type="checkbox"
                          checked={disciplinasSelecionadas.includes(parseInt(d.id, 10))}
                          onChange={() => handleCheckboxChange(d.id)}
                        />
                      </td>
                      <td style={{ padding: "8px" }}>{d.codigo}</td>
                      <td style={{ padding: "8px" }}>{d.nome}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Botões */}
        <div className="form-actions">
          <button type="button" className="btn btn-secondary" onClick={() => navigate("/professores")}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-primary">
            Salvar Professor
          </button>
        </div>

      </form>
    </div>
  );
};

export default CadastroProfessor;

